import Modal from "react-bootstrap/Modal";
import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
// import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import { formatDateTime } from "../../../common/Validations";
import Constants from "../../../common/Constants";
import { useTranslation } from "react-i18next";
// const moment = require("moment");

const OverviewTableModal = (props) => {
    const { t } = useTranslation();
  // const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    // {
    //   name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
    //   selector: (row) => row.requiredDate,
    //   sortable: true,
    //   width: "140px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
    //     </div>
    //   ),
    // },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_customer"),
    //   selector: (row) => row.customerName,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.customerName}</p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_plan"),
    //   selector: (row) => row.plan,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{moment(row.plan).format("MMM-YYYY")}</p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_planType"),
    //   selector: (row) => row.planType,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.planType}</p>
    //     </div>
    //   ),
    // },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span className="bg-table-status bg-table-documentNumber-status">
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_toMachine"),
    //   selector: (row) => row.toMachineCode,
    //   sortable: true,
    //   width: "250px",
    //   cell: (row) => (
    //     <>
    //       {row.toMachineCode ? (
    //         <span className="bg-table-status bg-table-second-status">
    //           {row.toMachineCode} - {row.toMachineName}
    //         </span>
    //       ) : (
    //         ""
    //       )}
    //     </>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_teamlead"),
    //   selector: (row) => row.loginUserId,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">
    //         {row.loginUserId}- {row.loginUserName}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_action"),
    //   selector: (row) => row.createdDate,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{formatDateTime(row.createdDate)}</p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_operator"),
    //   selector: (row) => row.operatorUserId,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">
    //         {row.operatorUserId}- {row.operatorUserName}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_action"),
    //   selector: (row) => row.operatorcreatedDate,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">
    //         {formatDateTime(row.operatorcreatedDate)}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.view_verified_checklist"),
    //   selector: (row) => row.verifiedCheckListData,
    //   cell: (row) => (
    //     <Button
    //       variant="outline-primary"
    //       // onClick={() => handleViewChecklist(row.verifiedCheckListData)}
    //     >
    //       {"View Checklist"}
    //     </Button>
    //   ),
    //   center: true,
    //   width: "250px",
    // },
  ];

  return (
    <Modal
      {...props}
      dialogClassName="modal-90w"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Jobcard Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <div>
           <DataTable
              // selectableRows={props.selectableRows ? true : false}
              columns={columnsData}
              data={props.tableData}
              // progressPending={loading}
              paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
              pagination
              // paginationServer
              // paginationTotalRows={totalRows}
              // onChangeRowsPerPage={handlePerRowsChange}
              // onChangePage={handlePageChange}
              // handleSelections
              // onSelectedRowsChange={props.handleSelections}
            />
          </div>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default OverviewTableModal;
